module.exports = __webpack_public_path__ + "b620c4d695195b32b479f9168492e061.png";